import React, { useState } from "react";
import { Box, Typography, InputBase, IconButton, Container } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Send } from "@mui/icons-material";
import { useIsMobile } from "../../../components/hooks/useIsMobile";
import client from "../../../api/client";
import { toast } from "react-toastify";


const SubscribeInput = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: "#FFFFFF",
  borderRadius: 50,
  padding: "4px 4px 4px 24px",
  width: "100%",
  maxWidth: 500,
}));

const SendButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: "#E25822", // Orange/coral color
  color: "#FFFFFF",
  width: 48,
  height: 48,
  "&:hover": {
    backgroundColor: "#C24812",
  },
}));

function NewsletterSubscription() {
  const mobile = useIsMobile();
  const [email, setEmail] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    // Handle subscription logic here
    try {
          const res = await client.post("newsletter", { email: email });
          if (res) {
            toast.success("User Subscribed  successfully");
            setEmail("");
          }
        } catch (error) {
          console.log(error?.response);
          toast.error("Failed to subscribe. Please try again later.");
        }
      
    // console.log("Subscribing email:", email);
    // Reset the form
    setEmail("");
    // You would typically send this to your API
  };

  return (
    <Box
      sx={{
        backgroundColor: "#2A2A2A", // Dark gray/black background
        padding: mobile ? "40px 20px" : "40px 60px",
        width: "100%",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: mobile ? "column" : "row",
            alignItems: "center",
            justifyContent: "center",
            gap: mobile ? 3 : 4,
          }}
        >
          
            <Typography
              variant="h6"
              sx={{
                color: "#FFFFFF",
                fontWeight: 500,
                whiteSpace: "nowrap",
              }}
            >
              Subscribe to our Newsletter
            </Typography>
        

            <form onSubmit={handleSubmit} style={{ width: "100%", maxWidth: 500 }}>
              <SubscribeInput>
                <InputBase
                  placeholder="Your email"
                  fullWidth
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  sx={{ color: "#333333" }}
                  inputProps={{
                    "aria-label": "email address",
                  }}
                />
                <SendButton type="submit" aria-label="subscribe">
                  <Send fontSize="small" />
                </SendButton>
              </SubscribeInput>
            </form>
      
        </Box>
      </Container>
    </Box>
  );
}

export default NewsletterSubscription;